module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start06_01-77bc79e8e482483202f89f39a88cc4ec.png";